export default __webpack_public_path__ + "static/screen_2_04-b243b137cc0d208e67c4187affef12a5.svg";